<template>
<div>
  <div v-if="bgvideo" class="bgvideo">
    <video class="bgvideo" autoplay playsinline muted loop ref="video">
      <source :src="bgvideo" type="video/mp4">
    </video>
  </div>
  <div v-if="bgimage" class="bgimage" v-bind:style="{ backgroundImage: 'url(' + bgimage + ')' }">
    
  </div>
  <section class="imgtext" v-bind:class="{ 'imgtext__invert': isInvert, 'hasbg': bgvideo || bgimage }">

    <div class="row imgtext__container">
      <div class="col-sm-6 imgtext__imgcontainer" v-bind:class="{ 'order-sm-2': isInvert }">
          <div class="imgtext__box" v-if="images || video">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="494" height="407" viewBox="0 0 494 407">
            <defs>
              <rect v-bind:id="'rectangle-a' + id" width="494" height="407" x="109" y="1757"/>
              <mask v-bind:id="'rectangle-b' + id" width="494" height="407" x="0" y="0" fill="#fff" maskContentUnits="userSpaceOnUse" maskUnits="objectBoundingBox">
                <use class="mask" stroke-dasharray="5" stroke-width="2" v-bind:xlink:href="'#rectangle-a' + id"/>
              </mask>
            </defs>
            <use fill="none" fill-rule="evenodd" 
            stroke="#D10A1C" stroke-dasharray="5" stroke-width="2" v-bind:mask="'url(#rectangle-b' + id +')'" transform="translate(-109 -1757)" v-bind:xlink:href="'#rectangle-a' + id"/>
          </svg>

          </div>
          <div class="imgtext__img">
            
            <div  v-if="images" ref="gallery">
              <img v-for="img in images" v-bind:key="img" v-bind:src="img"  />
            </div>
            <div v-if="video" class="video">
              <video class="imgtext__video" autoplay playsinline muted loop ref="video">
                <source :src="video" type="video/mp4">
              </video>
            </div>
          </div>
      </div>
      <div class="col-sm-6 imgtext__text" v-bind:class="{ 'order-sm-1': isInvert }">
        <Title v-if="title" v-bind:title="title"></Title>
        <div>
          <p v-if="text" v-html="text"></p>
          <slot></slot>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
import Title from '@/components/Title'
import { TweenMax, Power0, Power1 } from "gsap";
import TimelineMax from "gsap/TimelineMax";

import { tns } from "tiny-slider/src/tiny-slider"

function drawPath(p, tl, time) {
  //time = window.innerWidth <= 576 ? 0 : time
  tl.set(p, {className:"+=animate"});
}
export default {
  name: 'Banner',
  props: {
    title: String,
    text: String,
    images: Array,
    video: String,
    bgvideo: String,
    bgimage: String,
    isInvert: Boolean,
    bus: {}
  },
  data() {
    return {
      id: null,
      timelines: []
    }
  },
  methods: {
    TimeLineFactory(conf) {
      conf = conf || {}
      let t = new TimelineMax(conf)
      this.timelines.push(t)
      return t
    }
  },
  beforeDestroy() {
    for(let t of this.timelines) {
      t.kill()
    }
    TweenMax.killChildTweensOf(this.$el)
  },
  components: {
    Title
  },
  mounted() {
    this.id = this._uid
    require("@/js/vendor/SplitText.js")

    if (this.$refs.gallery && this.$refs.gallery.querySelectorAll('img').length > 1) {
        let slider = tns({
          container: this.$refs.gallery,
          items: 1,
          autoplay: true,
          controls: false,
          nav: false,
          autoplayButton: false
        });
    }
    
    this.$nextTick(() => {

      const tl = this.TimeLineFactory({
        paused: true
      })
      let title = this.$el.querySelector('.title h1, .astitle')
      let titlesplit
      if (title) {
        titlesplit = new SplitText(
          title, 
          { type: "chars" })
      }
      let text = this.$el.querySelectorAll('.imgtext__text')
      let tlbox = this.$el.querySelector('.imgtext__box')
      let image = this.$el.querySelector('.imgtext__img')

  
      if (title) {
        TweenMax.set(titlesplit.chars, {opacity: 0})
      }
      if (text) {
        TweenMax.set(text, {opacity: 0})
      }

      if (tlbox) {
        tl.set(tlbox, {className:"+=animate"});
      }
      let pt = window.innerWidth <= 576 ? '' : '+=1'
      tl.addLabel('start')
      if (image) {
        tl.from(image, 2.2, {opacity: 0, ease: Power1.easeOut}, pt);
      }
      if (title) {
        tl.staggerFromTo(titlesplit.chars, 0.6, 
          {
            yPercent: 20
          },
          {
            ease: Power0.easeOut,
            yPercent: 0,
            opacity: 1
          }, 0.03, 'start+=0.4')
      }
      if (text) {
        tl.fromTo(text, 1, 
          {
            yPercent: 6
          },
          {
            ease: Power1.easeOut,
            yPercent: 0,
            opacity: 1
          }, 'start+=0.4')
      }
      this.bus.$on('pagechange', data => {
        if (data == this.$el) {
          tl.play().timeScale(1)
        } else {
          tl.reverse().timeScale(2)
        }
      })

      if (this.$refs.video) {
        this.$refs.video.play()
      }
      this.bus.$on('pagechange', data => {
        if (this.$refs.video) {
          if (data == this.$el) {
            this.$refs.video.play()
          } else {
            this.$refs.video.pause()
          }
        }
      })      
      
    })
  }
}
</script>

<style scoped lang="scss">

img {
  max-width: 100%;
}

.title {
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
  margin-bottom: 30px;
}

.bgimage ,
.bgvideo {
  position: absolute;
  width: 100%;
  object-fit: cover;
  left: 0;
  top: 0;
  z-index: 0;

}
.bgvideo,
.bgvideo video{ 
  height: 100%;
}

.bgimage {
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
}

.imgtext {
  position: relative;
  z-index: 1
}

.imgtext__text {
  position: relative;
  z-index: 4;
  padding-top: 50px;
  @include media-breakpoint-up(md) {
    padding-top: 90px;
  }
  @include media-breakpoint-down(sm) {
    padding-right: 30px;
  }
}

@include media-breakpoint-up(md) {
  .imgtext:not(.imgtext__invert) .title {
    margin-left: -72px;
  }
  .imgtext.imgtext__invert {
    padding-left: 8%;
  }
}

.imgtext__imgcontainer {
  img {
    position: relative;
    z-index: 2;
  }
  @include media-breakpoint-down(sm) {
    overflow: hidden;
  }
}

.imgtext__img {
  overflow: hidden;
  position: relative;
}

.imgtext__video {
  max-width: 100%;
}

.imgtext__box {
  position: absolute;
  z-index: 0;
  height: 86%;
  width: 100%;
  svg {
    max-width: 100%;
  }
}

.imgtext:not(.imgtext__invert) {
  .imgtext__box {
    left: -4%;
    top: 15%;
    @include media-breakpoint-only(md) {
      top: -10%;
    }
  }
}
.imgtext__invert {
  .imgtext__box {
    right: -7%;
    top: 8%;
    @include media-breakpoint-only(md) {
      top: -8%;
    }
  }
}

.mask {
  fill: none;
  stroke: white;
  stroke-width: 4;
  stroke-dasharray: 1802;
  stroke-dashoffset: 1802;
}
.imgtext__box.animate .mask {
  animation: dash 1.5s cubic-bezier(0, 0, 0.29, 0.97) forwards;
}

/* does not work in IE, need JS to animate there */
@keyframes dash {
  from {
    stroke-dashoffset: 1802;
  }
  to {
    stroke-dashoffset: 0;
  }
}

</style>

<style lang="scss">
.tns-outer {
  .tns-liveregion,
  [data-action="stop"] {
    display: none;
  }
}
</style>

